/**
 * Pure YouTube URL helpers — kept separate from homepage static data so
 * review/MBA sections don't pull WHY_AMITY icons + next/dynamic into their graph.
 */

export function getYouTubeEmbedUrl(url: string): string {
  try {
    const u = new URL(url);

    if (u.pathname.startsWith("/shorts/")) {
      const id = u.pathname.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (u.hostname.includes("youtu.be")) {
      return `https://www.youtube.com/embed/${u.pathname.replace("/", "")}`;
    }

    const v = u.searchParams.get("v");
    if (v) return `https://www.youtube.com/embed/${v}`;

    if (u.pathname.includes("/embed/")) return url;

    return url;
  } catch {
    return url;
  }
}

export function getYouTubeVideoId(url: string): string | null {
  try {
    const u = new URL(url);

    if (u.pathname.startsWith("/shorts/")) {
      return u.pathname.split("/shorts/")[1].split("?")[0];
    }

    if (u.hostname.includes("youtu.be")) {
      return u.pathname.replace("/", "");
    }

    const v = u.searchParams.get("v");
    if (v) return v;

    if (u.pathname.includes("/embed/")) {
      return u.pathname.split("/embed/")[1];
    }

    return null;
  } catch {
    return null;
  }
}
